import { NgModule } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { appReducer } from '../domains/reducer';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { ServiceWorkerModule } from '@angular/service-worker';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { StoreRouterConnectingModule } from '@ngrx/router-store';
import { LemsarApiModule } from '@lemsar/api/api.module';
import { LemsarAuthModule } from '@lemsar/auth/auth.module';
import { LemsarStorageModule } from '@lemsar/storage/storage.module';
import { Initializer } from './app.initializer';
import { NotificationModule } from '@shared/module/notification/notification.module';
import { AppComponent } from './app.component';
import { routing } from './app.routes';
import { LemsarDefaultTemplateModule } from '../template/default/default-template.module';
import { UbudUserControlModule } from '@ubud/user-control';
import { UbudDropdownModule } from '@ubud/dropdown';
import { UbudTooltipModule } from '@ubud/tooltip';
import { UbudSidebarMenuModule } from '@ubud/menus';
import { UbudTemplateModule } from '@ubud/template';
import { UbudUtilitiesModule } from '@ubud/utilities';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NacoModule } from '@naker/naco';
import { LandingPage } from '../views/pages/landing.page';
import { LoadingBarRouterModule } from '@ngx-loading-bar/router';
import { LoadingBarHttpClientModule } from '@ngx-loading-bar/http-client';
import { DialogsModule } from '@progress/kendo-angular-dialog';
import { ServicePickerModule } from '@naker/service-picker';
import { GooglePlaceModule } from 'ngx-google-places-autocomplete';

@NgModule({
    declarations: [AppComponent, LandingPage],
    imports: [
        DialogsModule,
        BrowserModule,
        BrowserAnimationsModule,
        StoreModule.forRoot(appReducer),
        EffectsModule.forRoot([]),
        ServiceWorkerModule.register('/ngsw-worker.js', { enabled: environment.production }),
        NacoModule.forRoot({ clientId: environment.nacoClientId }),
        StoreDevtoolsModule.instrument(<any>{
            maxAgent: 25,
            logOnly: environment.production,
        }),
        StoreRouterConnectingModule,
        routing,
        UbudUtilitiesModule,
        UbudTemplateModule,
        UbudSidebarMenuModule,
        UbudTooltipModule,
        UbudDropdownModule,
        UbudUserControlModule,
        NotificationModule.forRoot(),
        LemsarDefaultTemplateModule,
        LemsarApiModule,
        LemsarAuthModule,
        LemsarStorageModule.forRoot(),
        NgbModule.forRoot(),

        LoadingBarHttpClientModule,
        LoadingBarRouterModule,
        ServicePickerModule.forRoot({ activeService: 'kelembagaan' }),
        GooglePlaceModule,
    ],
    providers: [Initializer],
    bootstrap: [AppComponent],
})
export class AppModule {}



// WEBPACK FOOTER //
// ./apps/frontend/src/bootstrap/app.module.ts